/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 包裹详情 的 **请求配置**
 *
 * @分类 旧接口文档/采购工作台
 * @请求头 `POST /erp/Supply/packageDetail`
 */
const postPackageDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Supply/packageDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPackageDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 包裹详情 的 **请求函数**
 *
 * @分类 旧接口文档/采购工作台
 * @请求头 `POST /erp/Supply/packageDetail`
 */
export const postPackageDetail = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postPackageDetailRequestConfig, requestData), ...args);
};
postPackageDetail.requestConfig = postPackageDetailRequestConfig;
/**
 * 接口 档口收包记录列表 的 **请求配置**
 *
 * @分类 旧接口文档/采购工作台
 * @请求头 `POST /erp/Supply/supplyPackageList`
 */
const postSupplyPackageListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/Supply/supplyPackageList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSupplyPackageList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 档口收包记录列表 的 **请求函数**
 *
 * @分类 旧接口文档/采购工作台
 * @请求头 `POST /erp/Supply/supplyPackageList`
 */
export const postSupplyPackageList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSupplyPackageListRequestConfig, requestData),
    ...args
  );
};
postSupplyPackageList.requestConfig = postSupplyPackageListRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 返回所有已启用的员工 的 **请求配置**
 *
 * @分类 管理员API
 * @请求头 `POST /erp/supply/getAllEnableAdmin`
 */
const postGetAllEnableAdminRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/supply/getAllEnableAdmin",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetAllEnableAdmin",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 返回所有已启用的员工 的 **请求函数**
 *
 * @分类 管理员API
 * @请求头 `POST /erp/supply/getAllEnableAdmin`
 */
export const postGetAllEnableAdmin = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetAllEnableAdminRequestConfig, requestData),
    ...args
  );
};
postGetAllEnableAdmin.requestConfig = postGetAllEnableAdminRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 修改供应商状态 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/UpdateSingleSupplyStatus`
 */
const postUpdateSingleSupplyStatusRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/UpdateSingleSupplyStatus",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUpdateSingleSupplyStatus",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 修改供应商状态 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/UpdateSingleSupplyStatus`
 */
export const postUpdateSingleSupplyStatus = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postUpdateSingleSupplyStatusRequestConfig, requestData),
    ...args
  );
};
postUpdateSingleSupplyStatus.requestConfig =
  postUpdateSingleSupplyStatusRequestConfig;
/**
 * 接口 供应商列表 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `GET /erp/Supply/SupplyList`
 */
const getSupplyListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/SupplyList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [
    "reject_accept",
    "special_sale",
    "goods_exempt_examine",
    "supply_character",
    "supply_level",
    "is_return_profit",
    "clearing_form",
    "period_profit",
    "pre_storage_admin",
    "is_participation_dispense",
    "is_sign_pingan_agreement",
    "take_stock_on_plan",
    "is_authentication",
    "is_offsite",
    "billing_type",
  ],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getSupplyList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 供应商列表 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `GET /erp/Supply/SupplyList`
 */
export const getSupplyList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getSupplyListRequestConfig, requestData), ...args);
};
getSupplyList.requestConfig = getSupplyListRequestConfig;
/**
 * 接口 供应商画像 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `GET /erp/Supply/profile`
 */
const getProfileRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/profile",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: ["supply_id"],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getProfile",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 供应商画像 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `GET /erp/Supply/profile`
 */
export const getProfile = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getProfileRequestConfig, requestData), ...args);
};
getProfile.requestConfig = getProfileRequestConfig;
/**
 * 接口 供应商退出免审 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/exitExemptExamine`
 */
const postExitExemptExamineRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/exitExemptExamine",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExitExemptExamine",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 供应商退出免审 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/exitExemptExamine`
 */
export const postExitExemptExamine = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postExitExemptExamineRequestConfig, requestData),
    ...args
  );
};
postExitExemptExamine.requestConfig = postExitExemptExamineRequestConfig;
/**
 * 接口 修改供应商经营信息 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/supply/updateManagement`
 */
const postUpdateManagementRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/supply/updateManagement",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUpdateManagement",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 修改供应商经营信息 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/supply/updateManagement`
 */
export const postUpdateManagement = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postUpdateManagementRequestConfig, requestData),
    ...args
  );
};
postUpdateManagement.requestConfig = postUpdateManagementRequestConfig;
/**
 * 接口 批量修改供应商「前置仓跟进人」 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/batchUpdateSupplyPreStorageAdmin`
 */
const postBatchUpdateSupplyPreStorageAdminRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/batchUpdateSupplyPreStorageAdmin",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchUpdateSupplyPreStorageAdmin",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量修改供应商「前置仓跟进人」 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/batchUpdateSupplyPreStorageAdmin`
 */
export const postBatchUpdateSupplyPreStorageAdmin = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postBatchUpdateSupplyPreStorageAdminRequestConfig, requestData),
    ...args
  );
};
postBatchUpdateSupplyPreStorageAdmin.requestConfig =
  postBatchUpdateSupplyPreStorageAdminRequestConfig;
/**
 * 接口 更改供应商支付方式 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/updatePayMethod`
 */
const postUpdatePayMethodRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/updatePayMethod",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUpdatePayMethod",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 更改供应商支付方式 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/updatePayMethod`
 */
export const postUpdatePayMethod = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postUpdatePayMethodRequestConfig, requestData),
    ...args
  );
};
postUpdatePayMethod.requestConfig = postUpdatePayMethodRequestConfig;
/**
 * 接口 更新平台化信息 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/saveSupplyPlatformInfo`
 */
const postSaveSupplyPlatformInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/saveSupplyPlatformInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSaveSupplyPlatformInfo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 更新平台化信息 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/saveSupplyPlatformInfo`
 */
export const postSaveSupplyPlatformInfo = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSaveSupplyPlatformInfoRequestConfig, requestData),
    ...args
  );
};
postSaveSupplyPlatformInfo.requestConfig =
  postSaveSupplyPlatformInfoRequestConfig;
/**
 * 接口 查询供应商经营信息 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/supply/getManagement`
 */
const postGetManagementRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/supply/getManagement",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetManagement",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 查询供应商经营信息 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/supply/getManagement`
 */
export const postGetManagement = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetManagementRequestConfig, requestData), ...args);
};
postGetManagement.requestConfig = postGetManagementRequestConfig;
/**
 * 接口 根据城市获取主市场列表 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/getMainMarket`
 */
const postGetMainMarketRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/getMainMarket",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetMainMarket",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 根据城市获取主市场列表 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/getMainMarket`
 */
export const postGetMainMarket = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetMainMarketRequestConfig, requestData), ...args);
};
postGetMainMarket.requestConfig = postGetMainMarketRequestConfig;
/**
 * 接口 获取子市场列表 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/getChildMarket`
 */
const postGetChildMarketRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/getChildMarket",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetChildMarket",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取子市场列表 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/getChildMarket`
 */
export const postGetChildMarket = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetChildMarketRequestConfig, requestData),
    ...args
  );
};
postGetChildMarket.requestConfig = postGetChildMarketRequestConfig;
/**
 * 接口 获取平台化信息 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/getSupplyPlatformInfo`
 */
const postGetSupplyPlatformInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/getSupplyPlatformInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetSupplyPlatformInfo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取平台化信息 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/getSupplyPlatformInfo`
 */
export const postGetSupplyPlatformInfo = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetSupplyPlatformInfoRequestConfig, requestData),
    ...args
  );
};
postGetSupplyPlatformInfo.requestConfig =
  postGetSupplyPlatformInfoRequestConfig;
/**
 * 接口 获取私密信息 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/getInformationPrivate`
 */
const postGetInformationPrivateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/getInformationPrivate",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetInformationPrivate",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取私密信息 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/getInformationPrivate`
 */
export const postGetInformationPrivate = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetInformationPrivateRequestConfig, requestData),
    ...args
  );
};
postGetInformationPrivate.requestConfig =
  postGetInformationPrivateRequestConfig;
/**
 * 接口 设置供应商商家性质 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/setSupplyCharacter`
 */
const postSetSupplyCharacterRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/setSupplyCharacter",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetSupplyCharacter",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置供应商商家性质 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/setSupplyCharacter`
 */
export const postSetSupplyCharacter = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetSupplyCharacterRequestConfig, requestData),
    ...args
  );
};
postSetSupplyCharacter.requestConfig = postSetSupplyCharacterRequestConfig;
/**
 * 接口 销户 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/closeAcctInfo`
 */
const postCloseAcctInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/closeAcctInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCloseAcctInfo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 销户 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/closeAcctInfo`
 */
export const postCloseAcctInfo = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postCloseAcctInfoRequestConfig, requestData), ...args);
};
postCloseAcctInfo.requestConfig = postCloseAcctInfoRequestConfig;
/**
 * 接口 导出供应商合同信息 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/supply/exportSupplyContract`
 */
const postExportSupplyContractRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/supply/exportSupplyContract",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportSupplyContract",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出供应商合同信息 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/supply/exportSupplyContract`
 */
export const postExportSupplyContract = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportSupplyContractRequestConfig, requestData),
    ...args
  );
};
postExportSupplyContract.requestConfig = postExportSupplyContractRequestConfig;
/**
 * 接口 批量更新供应商状态 的 **请求配置**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/batchUpdateSupply`
 */
const postBatchUpdateSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/Supply/batchUpdateSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchUpdateSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量更新供应商状态 的 **请求函数**
 *
 * @分类 旧接口文档/供应商
 * @请求头 `POST /erp/Supply/batchUpdateSupply`
 */
export const postBatchUpdateSupply = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postBatchUpdateSupplyRequestConfig, requestData),
    ...args
  );
};
postBatchUpdateSupply.requestConfig = postBatchUpdateSupplyRequestConfig;
const mockUrl_0_0_0_4 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_4 = "";
const prodUrl_0_0_0_4 = "";
const dataKey_0_0_0_4 = "data";
/**
 * 接口 获取市场打卡范围 的 **请求配置**
 *
 * @分类 旧接口文档/市场专员打卡
 * @请求头 `POST /erp/Supply/getMarketClockInRange`
 */
const postGetMarketClockInRangeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Supply/getMarketClockInRange",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetMarketClockInRange",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取市场打卡范围 的 **请求函数**
 *
 * @分类 旧接口文档/市场专员打卡
 * @请求头 `POST /erp/Supply/getMarketClockInRange`
 */
export const postGetMarketClockInRange = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetMarketClockInRangeRequestConfig, requestData),
    ...args
  );
};
postGetMarketClockInRange.requestConfig =
  postGetMarketClockInRangeRequestConfig;
/**
 * 接口 获取市场打卡记录 的 **请求配置**
 *
 * @分类 旧接口文档/市场专员打卡
 * @请求头 `POST /erp/Supply/getMarketClockInList`
 */
const postGetMarketClockInListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Supply/getMarketClockInList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetMarketClockInList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取市场打卡记录 的 **请求函数**
 *
 * @分类 旧接口文档/市场专员打卡
 * @请求头 `POST /erp/Supply/getMarketClockInList`
 */
export const postGetMarketClockInList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetMarketClockInListRequestConfig, requestData),
    ...args
  );
};
postGetMarketClockInList.requestConfig = postGetMarketClockInListRequestConfig;
/**
 * 接口 设置市场人员打卡范围 的 **请求配置**
 *
 * @分类 旧接口文档/市场专员打卡
 * @请求头 `POST /erp/Supply/setMarketClockInRange`
 */
const postSetMarketClockInRangeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/Supply/setMarketClockInRange",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetMarketClockInRange",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置市场人员打卡范围 的 **请求函数**
 *
 * @分类 旧接口文档/市场专员打卡
 * @请求头 `POST /erp/Supply/setMarketClockInRange`
 */
export const postSetMarketClockInRange = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetMarketClockInRangeRequestConfig, requestData),
    ...args
  );
};
postSetMarketClockInRange.requestConfig =
  postSetMarketClockInRangeRequestConfig;
const mockUrl_0_0_0_6 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_6 = "";
const prodUrl_0_0_0_6 = "";
const dataKey_0_0_0_6 = "data";
/**
 * 接口 前置仓邀约池规则配置 导入 的 **请求配置**
 *
 * @分类 旧接口文档/前置仓邀约池
 * @请求头 `POST /erp/Supply/importInvitationRule`
 */
const postImportInvitationRuleRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_6,
  devUrl: devUrl_0_0_0_6,
  prodUrl: prodUrl_0_0_0_6,
  path: "/erp/Supply/importInvitationRule",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportInvitationRule",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 前置仓邀约池规则配置 导入 的 **请求函数**
 *
 * @分类 旧接口文档/前置仓邀约池
 * @请求头 `POST /erp/Supply/importInvitationRule`
 */
export const postImportInvitationRule = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportInvitationRuleRequestConfig, requestData),
    ...args
  );
};
postImportInvitationRule.requestConfig = postImportInvitationRuleRequestConfig;
/**
 * 接口 前置仓邀约池规则配置 导出 的 **请求配置**
 *
 * @分类 旧接口文档/前置仓邀约池
 * @请求头 `POST /erp/Supply/exportInvitationRule`
 */
const postExportInvitationRuleRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_6,
  devUrl: devUrl_0_0_0_6,
  prodUrl: prodUrl_0_0_0_6,
  path: "/erp/Supply/exportInvitationRule",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportInvitationRule",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 前置仓邀约池规则配置 导出 的 **请求函数**
 *
 * @分类 旧接口文档/前置仓邀约池
 * @请求头 `POST /erp/Supply/exportInvitationRule`
 */
export const postExportInvitationRule = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportInvitationRuleRequestConfig, requestData),
    ...args
  );
};
postExportInvitationRule.requestConfig = postExportInvitationRuleRequestConfig;
const mockUrl_0_0_0_8 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_8 = "";
const prodUrl_0_0_0_8 = "";
const dataKey_0_0_0_8 = "data";
/**
 * 接口 模糊搜索内部已启用的员工 的 **请求配置**
 *
 * @分类 仓储API
 * @请求头 `POST /erp/Supply/searchEnabledAdminByNameLike`
 */
const postSearchEnabledAdminByNameLikeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_8,
  devUrl: devUrl_0_0_0_8,
  prodUrl: prodUrl_0_0_0_8,
  path: "/erp/Supply/searchEnabledAdminByNameLike",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSearchEnabledAdminByNameLike",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 模糊搜索内部已启用的员工 的 **请求函数**
 *
 * @分类 仓储API
 * @请求头 `POST /erp/Supply/searchEnabledAdminByNameLike`
 */
export const postSearchEnabledAdminByNameLike = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSearchEnabledAdminByNameLikeRequestConfig, requestData),
    ...args
  );
};
postSearchEnabledAdminByNameLike.requestConfig =
  postSearchEnabledAdminByNameLikeRequestConfig;
const mockUrl_0_0_0_9 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_9 = "";
const prodUrl_0_0_0_9 = "";
const dataKey_0_0_0_9 = "data";
/**
 * 接口 商家列表|导出 的 **请求配置**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/supply/SupplyList`
 */
const postSupplyListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/supply/SupplyList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSupplyList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家列表|导出 的 **请求函数**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/supply/SupplyList`
 */
export const postSupplyList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSupplyListRequestConfig, requestData), ...args);
};
postSupplyList.requestConfig = postSupplyListRequestConfig;
/**
 * 接口 编辑商家信息 的 **请求配置**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/supply/UpdateSupply`
 */
const postUpdateSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/supply/UpdateSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postUpdateSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 编辑商家信息 的 **请求函数**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/supply/UpdateSupply`
 */
export const postUpdateSupply = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postUpdateSupplyRequestConfig, requestData), ...args);
};
postUpdateSupply.requestConfig = postUpdateSupplyRequestConfig;
/**
 * 接口 导出专场当天报单白名单 的 **请求配置**
 *
 * @分类 商家API/商家管理
 * @请求头 `GET /erp/Supply/exportAutoStockPlan`
 */
const getExportAutoStockPlanRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/Supply/exportAutoStockPlan",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getExportAutoStockPlan",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出专场当天报单白名单 的 **请求函数**
 *
 * @分类 商家API/商家管理
 * @请求头 `GET /erp/Supply/exportAutoStockPlan`
 */
export const getExportAutoStockPlan = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getExportAutoStockPlanRequestConfig, requestData),
    ...args
  );
};
getExportAutoStockPlan.requestConfig = getExportAutoStockPlanRequestConfig;
/**
 * 接口 导入专场当天报单白名单 的 **请求配置**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/Supply/importAutoStockPlan`
 */
const postImportAutoStockPlanRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/Supply/importAutoStockPlan",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportAutoStockPlan",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入专场当天报单白名单 的 **请求函数**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/Supply/importAutoStockPlan`
 */
export const postImportAutoStockPlan = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postImportAutoStockPlanRequestConfig, requestData),
    ...args
  );
};
postImportAutoStockPlan.requestConfig = postImportAutoStockPlanRequestConfig;
/**
 * 接口 导入让利指定货号文件 的 **请求配置**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/supply/importReturnProfitGoods`
 */
const postImportReturnProfitGoodsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/supply/importReturnProfitGoods",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportReturnProfitGoods",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入让利指定货号文件 的 **请求函数**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/supply/importReturnProfitGoods`
 */
export const postImportReturnProfitGoods = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportReturnProfitGoodsRequestConfig, requestData),
    ...args
  );
};
postImportReturnProfitGoods.requestConfig =
  postImportReturnProfitGoodsRequestConfig;
/**
 * 接口 新增商家信息 的 **请求配置**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/supply/AddSupply`
 */
const postAddSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/supply/AddSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postAddSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 新增商家信息 的 **请求函数**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/supply/AddSupply`
 */
export const postAddSupply = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postAddSupplyRequestConfig, requestData), ...args);
};
postAddSupply.requestConfig = postAddSupplyRequestConfig;
/**
 * 接口 批量绑定商家运营跟进人 的 **请求配置**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/Supply/batchUpdateFollowerAdmin`
 */
const postBatchUpdateFollowerAdminRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/Supply/batchUpdateFollowerAdmin",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchUpdateFollowerAdmin",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量绑定商家运营跟进人 的 **请求函数**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/Supply/batchUpdateFollowerAdmin`
 */
export const postBatchUpdateFollowerAdmin = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postBatchUpdateFollowerAdminRequestConfig, requestData),
    ...args
  );
};
postBatchUpdateFollowerAdmin.requestConfig =
  postBatchUpdateFollowerAdminRequestConfig;
/**
 * 接口 获取所有启用的业绩归属市场 的 **请求配置**
 *
 * @分类 商家API/商家管理
 * @请求头 `GET /erp/Supply/getAttributableMarketList`
 */
const getGetAttributableMarketListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/Supply/getAttributableMarketList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetAttributableMarketList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取所有启用的业绩归属市场 的 **请求函数**
 *
 * @分类 商家API/商家管理
 * @请求头 `GET /erp/Supply/getAttributableMarketList`
 */
export const getGetAttributableMarketList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getGetAttributableMarketListRequestConfig, requestData),
    ...args
  );
};
getGetAttributableMarketList.requestConfig =
  getGetAttributableMarketListRequestConfig;
/**
 * 接口 批量绑定业绩归属市场 的 **请求配置**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/Supply/batchBindAttributableMarket`
 */
const postBatchBindAttributableMarketRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/Supply/batchBindAttributableMarket",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchBindAttributableMarket",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量绑定业绩归属市场 的 **请求函数**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/Supply/batchBindAttributableMarket`
 */
export const postBatchBindAttributableMarket = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postBatchBindAttributableMarketRequestConfig, requestData),
    ...args
  );
};
postBatchBindAttributableMarket.requestConfig =
  postBatchBindAttributableMarketRequestConfig;
/**
 * 接口 供应商列表筛选条件 的 **请求配置**
 *
 * @分类 商家API/商家管理
 * @请求头 `GET /erp/Supply/optionsForSupplyList`
 */
const getOptionsForSupplyListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/Supply/optionsForSupplyList",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getOptionsForSupplyList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 供应商列表筛选条件 的 **请求函数**
 *
 * @分类 商家API/商家管理
 * @请求头 `GET /erp/Supply/optionsForSupplyList`
 */
export const getOptionsForSupplyList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getOptionsForSupplyListRequestConfig, requestData),
    ...args
  );
};
getOptionsForSupplyList.requestConfig = getOptionsForSupplyListRequestConfig;
/**
 * 接口 批量处理能否参与特价销售 的 **请求配置**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/Supply/batchUpdateSpecialSaleStatus`
 */
const postBatchUpdateSpecialSaleStatusRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/Supply/batchUpdateSpecialSaleStatus",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postBatchUpdateSpecialSaleStatus",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 批量处理能否参与特价销售 的 **请求函数**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/Supply/batchUpdateSpecialSaleStatus`
 */
export const postBatchUpdateSpecialSaleStatus = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postBatchUpdateSpecialSaleStatusRequestConfig, requestData),
    ...args
  );
};
postBatchUpdateSpecialSaleStatus.requestConfig =
  postBatchUpdateSpecialSaleStatusRequestConfig;
/**
 * 接口 校验店铺是否可绑定 的 **请求配置**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/Supply/checkShop`
 */
const postCheckShopRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/Supply/checkShop",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCheckShop",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 校验店铺是否可绑定 的 **请求函数**
 *
 * @分类 商家API/商家管理
 * @请求头 `POST /erp/Supply/checkShop`
 */
export const postCheckShop = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postCheckShopRequestConfig, requestData), ...args);
};
postCheckShop.requestConfig = postCheckShopRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/supply.js